import { Boundary, Menu, MenuItem, Position, Tag } from "@blueprintjs/core"
import CustomPopover from "components/Atoms/CustomPopover"
import StyledLink from "components/Atoms/StyledLink"
import CustomOverflowList from "components/Molecules/CustomOverflowList"
import React from "react"
const renderVisible = (item, index) => {
  return (
    <StyledLink
      text={false}
      key={item.id ? item.id : index}
      to={`/d/registration/crop/${item.id}`}
      className="ml-2"
    >
      <Tag round={true} interactive={true} intent="none" minimal={true}>
        {item.name}
      </Tag>
    </StyledLink>
  )
}
const renderOverflow = items => {
  return (
    <CustomPopover
      position={Position.BOTTOM}
      content={
        <Menu className="vt-plot-list-menu">
          {items.map(item => (
            <StyledLink
              text={false}
              key={item.id}
              to={`/d/registration/crop/${item.id}`}
            >
              <MenuItem
                tagName="span"
                icon="tree"
                text={item.name}
                label={item?.commodity?.name}
              />
            </StyledLink>
          ))}
        </Menu>
      }
    >
      <Tag round={true} className="ml-2" interactive={true}>
        + {items.length}
      </Tag>
    </CustomPopover>
  )
}
const DepartmentVarietyList = ({ varieties }) => {
  return (
    <CustomOverflowList
      items={varieties}
      overflowRenderer={renderOverflow}
      visibleItemRenderer={renderVisible}
      collapseFrom={Boundary.END}
    ></CustomOverflowList>
  )
}

export default DepartmentVarietyList
